__turbopack_context__.v({
  "card": "OutfitCard-module-scss-module__Bv0QVW__card",
  "item": "OutfitCard-module-scss-module__Bv0QVW__item",
  "list": "OutfitCard-module-scss-module__Bv0QVW__list",
});
